import React from "react";
import styled from "styled-components";
import { ITheme } from "../../Themes/ThemeTypes";

const Div = styled.div<{ theme: ITheme }>`
  margin-right: 16px;
`;

interface ListItemLeadingElementProps {
  children: React.ReactNode;
}

const ListItemLeadingElement: React.FC<ListItemLeadingElementProps> = ({ children }) => {
  return <Div>{children}</Div>;
};

export default ListItemLeadingElement;
